/* eslint-disable */
import React, { useState, useEffect, memo, useRef } from 'react'

const AdSense = ({ slot = 0, responsive, height, margin = 0, onlyView }) => {
    const [state, setstate] = useState(0) // 0: 로드전 1: 로드성공 2: 로드실패
    const ins = useRef(null)

    let observer = {}

    useEffect(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({})
        loadAdSense()

        return () => observer.disconnect()
    }, [])

    const loadAdSense = () => {
        observer = new MutationObserver(() => {
            const status = ins.current.dataset.adStatus
            if (status === 'filled') {
                setstate(1)
                observer.disconnect()
            } else if (status === 'unfilled') {
                setstate(2)
                observer.disconnect()
            }
        })
        observer.observe(ins.current, {
            attributes: true
        })
    }

    if (state === 2) return <div style={{ display: 'none' }}>unfilled</div>
    return (
        <div style={{
            height: onlyView
                ? '1px'
                : state === 1 ? 'auto' : '0',
            overflow: 'hidden'
        }}>
            <ins
                ref={ins}
                className="adsbygoogle"
                style={{
                    display: 'block',
                    height: responsive ? 'auto ' : height || 'auto',
                    margin,
                }}
                data-ad-client="ca-pub-2030498062862537"
                data-ad-slot={slot}
                data-ad-format={ // auto, rectangle, vertical, horizontal
                    responsive
                        ? responsive === true
                            ? 'auto'
                            : responsive
                        : ''
                }
                data-full-width-responsive={responsive ? 'true' : 'false'}
            />
        </div>
    )
}

export default memo(AdSense)



// WEBPACK FOOTER //
// ./src/estimate_list/components/adSense/index.js